import type { FernieEntityContext, FernieEntityType } from "~/store/fernieActionSlice";

const ENTITY_LABELS: Record<FernieEntityType, string> = {
	customer: "customer",
	item: "item",
	masterOrder: "master order",
	materialItem: "material item",
	order: "order",
	purchaseOrder: "purchase order"
};

const describeEntity = (entity: FernieEntityContext, label: string): string => {
	const named = entity.displayName ? `${label} ${entity.displayName}` : label;
	return `${named} (entityType: ${entity.entityType}, entityId: ${entity.entityId})`;
};

const buildEntityContext = (entity: FernieEntityContext | null): string => {
	if (entity === null) return "";
	const label = ENTITY_LABELS[entity.entityType];
	return (
		`[Current record: ${describeEntity(entity, label)}]\n` +
		`The user is viewing this ${label} detail page. When they say "this", "this ${label}", "this record", ` +
		`"what am I looking at", or "summarize this" without naming an id, resolve it to this record.`
	);
};

export default buildEntityContext;
